import React from "react"
import HeadingL from "../../components/shared/HeadingL"
import Layout from "../../components/do/Layout"
import SEO from "../../components/Seo"
import { PAGE } from "../../constants"
import AssessmentPage from "../../components/do/SupportProgramPage"

const support_program = () => (
  <Layout>
    <SEO title={PAGE.title.support_program} siteTitle="do" />
    <HeadingL title={PAGE.title.support_program} target="do" />
    <AssessmentPage />
  </Layout>
)

export default support_program;
